var __WEBPACK_NAMESPACE_OBJECT__ = require("@sentry/browser");